import { CHECK_PAYMENT_INTENT, CHECK_PAYMENT_INTENT_FAILURE, CHECK_PAYMENT_INTENT_SUCCESS, CREATE_MONNIFY_PAYMENT, CREATE_MONNIFY_PAYMENT_FAILURE, CREATE_MONNIFY_PAYMENT_SUCCESS, CREATE_OPAY_PAYMENT, CREATE_OPAY_PAYMENT_FAILURE, CREATE_OPAY_PAYMENT_SUCCESS, CREATE_PAYMENT_INTENT, CREATE_PAYMENT_INTENT_FAILURE, CREATE_PAYMENT_INTENT_SUCCESS, DISABLE_CART, ENABLE_CART, RESET_CART, RESET_PAYMENT, RESET_PAYMENT_INTENT, UPDATE_PAYMENT_INTENT, UPDATE_PAYMENT_INTENT_FAILURE, UPDATE_PAYMENT_INTENT_SUCCESS } from "../ActionTypes";

export const createOpayPayment = (payload) => ({
    type: CREATE_OPAY_PAYMENT,
    payload
});
export const createOpayPaymentSuccess = (payload) => ({
    type: CREATE_OPAY_PAYMENT_SUCCESS,
    payload
});
export const createOpayPaymentFailure = (payload) => ({
    type: CREATE_OPAY_PAYMENT_FAILURE,
    payload
});
export const createMonnifyPayment = (payload) => ({
    type: CREATE_MONNIFY_PAYMENT,
    payload
});
export const createMonnifyPaymentSuccess = (payload) => ({
    type: CREATE_MONNIFY_PAYMENT_SUCCESS,
    payload
});
export const createMonnifyPaymentFailure = (payload) => ({
    type: CREATE_MONNIFY_PAYMENT_FAILURE,
    payload
});
export const resetPayment = (payload) => ({
    type: RESET_PAYMENT,
    payload
});
export const createPaymentIntent = (payload) => ({
    type: CREATE_PAYMENT_INTENT,
    payload
});
export const createPaymentIntentSuccess = (payload) => ({
    type: CREATE_PAYMENT_INTENT_SUCCESS,
    payload
});
export const createPaymentIntentFailure = (payload) => ({
    type: CREATE_PAYMENT_INTENT_FAILURE,
    payload
});
export const checkPaymentIntent = () => ({
    type: CHECK_PAYMENT_INTENT,
    
});
export const checkPaymentIntentSuccess = (payload) => ({
    type: CHECK_PAYMENT_INTENT_SUCCESS,
    payload
    
});
export const checkPaymentIntentFailure = (payload) => ({
    type: CHECK_PAYMENT_INTENT_FAILURE,
    payload
    
});

export const updatePaymentIntent = (payload) => ({
    type: UPDATE_PAYMENT_INTENT,
    payload
});
export const updatePaymentIntentSuccess = (payload) => ({
    type: UPDATE_PAYMENT_INTENT_SUCCESS,
    payload
});
export const updatePaymentIntentFailure = (payload) => ({
    type: UPDATE_PAYMENT_INTENT_FAILURE,
    payload
});
export const resetPaymentIntent = (payload) => ({
    type: RESET_PAYMENT_INTENT,
    payload
});

export const disableCart = () => ({
    type: DISABLE_CART,
});
export const enableCart = () => ({
    type: ENABLE_CART,
});

export const resetCart = () => ({
    type: RESET_CART,
});